import MAP_LOCALITY from 'shared-constants/src/mapGenericLocality';

export default ({ searchAddress = null, drawingData }) => {
  const generic = JSON.parse(JSON.stringify(MAP_LOCALITY));

  if (!searchAddress) {
    if (drawingData?.polygon) {
      generic.name = 'Area disegnata';
    }
    return [generic];
  }

  let drawingInfos = '';

  if (drawingData?.circle) {
    const { radius } = drawingData.circle;
    drawingInfos = radius > 1000 ? `${Math.round(radius / 1000)}km ` : `${radius}m `;
    generic.radius = drawingInfos.trim();
    generic.streetName = searchAddress.name;
    generic.city = searchAddress.parent;
  } else if (drawingData?.nearbyCenter) {
    const {
      travelTime, travelMode,
    } = drawingData;
    
    let mode = '';
    switch (travelMode) {
      case 'walk':
        mode = 'a piedi';
        break;
      case 'bike':
        mode = 'in bici';
        break;
      case 'car':
        mode = 'in auto';
        break;
    }
    drawingInfos = `${travelTime} min. ${mode} da `;
    generic.travelTime = `${travelTime} min.`;
    generic.travelMode = mode;
    generic.streetName = searchAddress.name;
    generic.city = searchAddress.parent;
  }

  generic.name = `${drawingInfos}${searchAddress.name}, ${searchAddress.parent}`;  
  return [generic];
};
